module.exports = __webpack_public_path__ + "static/media/hr-HR.f8e74b50.md";